import {AbstractResource} from 'vue3-starter/src/typescript/resource/AbstractResource';
import type {ActivityLocationResource, AddressResource, MissionPreferenceResource, WorkplacePreferenceResourceValue} from '@/types/api-raw-types';

export class LocationPreferences extends AbstractResource {
    address: AddressResource;
    preference: WorkplacePreferenceResourceValue;
    addressRadius: number;
    activityLocations: ActivityLocationResource[];
    willingnessToTravelInternationally: boolean;
    travelLocations: string[];
    override links: any;

    constructor(locationPreferencesResources: MissionPreferenceResource) {
        super(locationPreferencesResources);
        this.address = locationPreferencesResources.workplace.address;
        this.preference = locationPreferencesResources.workplace.preference;
        this.activityLocations = locationPreferencesResources.workplace.activityLocations;
        this.addressRadius = locationPreferencesResources.workplace.addressRadius;
        this.links = locationPreferencesResources._links;
        this.willingnessToTravelInternationally = locationPreferencesResources.workplace.willingnessToTravelInternationally;
        this.travelLocations = locationPreferencesResources.workplace.travelLocations;
    }

    toJSON() {
        return {
            ...this,
        };
    }
}
